export enum Frequency {
  DAILY = 'Daily',
  CYCLE = 'Cycle',
  YEAR = 'Year',
}
